import flow from "lodash/fp/flow";
import capitalize from "lodash/fp/capitalize";
import identity from "lodash/fp/identity";
import moment from "moment";
import constants from "../../core/constants";
import { toObject } from "../../core/utils";

class TagPageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    const format = (item) => {
      item.name = capitalize(item.name);
      item.createdAt = moment(item.createdAt).format(constants.dateFormat);
      return item;
    };

    return toObject(flow([format, identity])(data));
  }
}

export default TagPageTransform;



// WEBPACK FOOTER //
// ./src/pages/tag/tag.transforms.js